import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum ProductShipmentBundleFields {
    PRODUCT = 'product',
    AMOUNT = 'amount',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ProductShipmentBundleFields {
    type Data = { text: string; readonly?: true; updateOnly?: true; };

    export const Record: Record<ProductShipmentBundleFields, Data> = {
        [ProductShipmentBundleFields.PRODUCT]: {
            text: 'Produkt',
        },
        [ProductShipmentBundleFields.AMOUNT]: {
            text: 'Menge',
        },

        [ProductShipmentBundleFields.CREATED_AT]: {
            text: 'Erstellt am',
        },
        [ProductShipmentBundleFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
        },
    }

    export const Items = mapRecordToItems(Record);
}
